import React, { useCallback, useContext, useEffect } from 'react'
import { Modal } from '../../../components/modals/modal'
import { useStoreModals } from '../../../hooks/modals/use-store-modals'
import { buildPaywallUrl } from '../../../hooks/paywall'
import { ContextShell } from '../../context'

export const ModalExternalPaywall: React.FC = () => {
  const {
    modalExternalPaywall: { params, show, onDismiss }
  } = useStoreModals()
  const {
    user,
    event: { sendEventPostHog }
  } = useContext(ContextShell)

  const sendEventPaywallView = useCallback(() => {
    if (!params) return

    sendEventPostHog({
      name: 'purchase_flow:paywall_view',
      event_category: 'growth',
      customAttributes: {
        source: params.source || 'not_set',
        paywall_plan: params.plan,
        current_subscription_plan: user?.subscription?.plan,
        current_subscription_plan_cycle: user?.subscription?.details?.planCycle,
        current_subscription_type:
          user?.subscription?.subscriptionType === 'individual'
            ? 'individual'
            : 'group'
      }
    })
  }, [
    params,
    user?.subscription?.plan,
    user?.subscription?.details?.planCycle,
    user?.subscription?.subscriptionType,
    sendEventPostHog
  ])

  useEffect(() => {
    if (!show) return

    sendEventPaywallView()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  if (!show || !params) {
    return null
  }

  return (
    <Modal
      label={params.paywall}
      targetId="shell-app"
      isOpen={show}
      onClose={onDismiss}
      shouldCloseOnOverlayClick
      showCloseButton
      modalClassName="w-full md:min-w-[600px] lg:min-w-[800px] max-w-[780px] !h-[600px] overflow-hidden relative rounded-xl bg-black border border-solid border-white/10 [&>div]:w-full [&>div]:h-full [&>div>div]:w-full [&>div>div]:h-full"
      closeButtonClassName="!absolute !z-30 right-0 !p-3"
    >
      <iframe
        src={buildPaywallUrl(params)}
        title={params.paywall}
        className="w-full h-full border-0 !bg-black"
      />
    </Modal>
  )
}
